import AddSchool from "../../Components/Modals/AddSchool";
import Table from "../../Components/Table";
import { deleteSchoolById, getAllSchoolsPagination } from "../../Services/MasterService";

const School = () => {
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "Ttitle",
            value: "title"
        },

        {
            label: "Background Image",
            value: "background_image",
                        renderValue: (value) => {
                return (
                    <img width={70} src={value} alt="..." class="img-thumbnail"/>
                )
            }
        },
        {
            label: "Image",
            value: "image",
                        renderValue: (value) => {
                return (
                    <img width={70} src={value} alt="..." class="img-thumbnail"/>
                )
            }
        },
        {
            label: "city",
            value: "city_name"
        },
        {
            label: "Status",
            value: "status_name",
        },
        {
            label: "Description",
            value: "description",
        },
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddSchool data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllSchoolsPagination}
            columns={columns}
            title={"Schools Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteSchoolById}
        />
    );
}

export default School;